import {TabIds, TabKey} from '../../utils/enums';

export const tabImagesArray = [
  require('../../assets/images/homeTabs/medicalUpdates.png'),
  require('../../assets/images/homeTabs/guidelines.png'),
  require('../../assets/images/homeTabs/treatmentOptions.png'),
  require('../../assets/images/homeTabs/congresses.png'),
  require('../../assets/images/homeTabs/drugsAndDiseases.png'),
  require('../../assets/images/homeTabs/drugsAndDiseases.png'),
  require('../../assets/images/homeTabs/media.png'),
  require('../../assets/images/homeTabs/diagnosticTools.png'),
  require('../../assets/images/homeTabs/latestInnovations.png'),
  require('../../assets/images/homeTabs/labValues.png'),
  require('../../assets/images/homeTabs/medicalCalculators.png'),
  require('../../assets/images/homeTabs/medicalJobOpportunities.png'),
];

export const tabImages: any = {
  [TabIds.LatestUpdates]: require('../../assets/images/homeTabs/medicalUpdates.png'),
  [TabIds.Guidelines]: require('../../assets/images/homeTabs/guidelines.png'),
  [TabIds.TreatmentOptions]: require('../../assets/images/homeTabs/treatmentOptions.png'),
  [TabIds.Congresses]: require('../../assets/images/homeTabs/congresses.png'),
  [TabIds.Drugs]: require('../../assets/images/homeTabs/drugsAndDiseases.png'),
  [TabIds.Diseases]: require('../../assets/images/homeTabs/drugsAndDiseases.png'),
  [TabIds.Media]: require('../../assets/images/homeTabs/media.png'),
  [TabIds.DiagnosticTools]: require('../../assets/images/homeTabs/diagnosticTools.png'),
  [TabIds.LatestInnovations]: require('../../assets/images/homeTabs/latestInnovations.png'),
  [TabIds.LaboratoryValues]: require('../../assets/images/homeTabs/labValues.png'),
  [TabIds.MedicalCalculators]: require('../../assets/images/homeTabs/medicalCalculators.png'),
  [TabIds.MedicalJobOpportunities]: require('../../assets/images/homeTabs/medicalJobOpportunities.png'),
  [TabIds.ClinicalCases]: require('../../assets/images/homeTabs/clinicalCase.png'),
  [TabIds.MedicalReports]: require('../../assets/images/homeTabs/medicalUpdates.png'),
  [TabIds.MonitoringDiseaseProgression]: require('../../assets/images/homeTabs/diagnosticTools.png'),
  [TabIds.FunctionalMedicineSupport]: require('../../assets/images/homeTabs/medicalUpdates.png'),
  [TabIds.PersonalizedGenomicsAnalytics]: require('../../assets/images/homeTabs/latestInnovations.png'),
  [TabIds.AnomaliesDetection]: require('../../assets/images/homeTabs/diagnosticTools.png'),
  [TabIds.DiseasesPrediction]: require('../../assets/images/homeTabs/diagnosticTools.png'),
  [TabIds.SurvivalAnalysis]: require('../../assets/images/homeTabs/diagnosticTools.png'),
  [TabIds.CompareYourCaseWithSimilar]: require('../../assets/images/homeTabs/clinicalCase.png'),
  [TabIds.LifeguardsPredictedAlerts]: require('../../assets/images/homeTabs/diagnosticTools.png'),
  [TabIds.EarlyStageAsymptomaticDisease]: require('../../assets/images/homeTabs/diagnosticTools.png'),
  [TabIds.QA]: require('../../assets/images/homeTabs/qna.png'),
};

export const homePopularTopicsTabs = [
  {
    id: 0,
    label: 'clinicalCase',
    img: require('../../assets/images/homeTabs/clinicalCase.png'),
  },
  {
    id: 3,
    label: 'qna',
    img: require('../../assets/images/homeTabs/qna.png'),
  },
  {
    id: 1,
    label: 'medicalUpdates',
    img: require('../../assets/images/homeTabs/medicalUpdates.png'),
  },
  {
    id: 4,
    label: 'drugsAndDiseases',
    img: require('../../assets/images/homeTabs/drugsAndDiseases.png'),
  },
  {
    id: 14,
    label: 'medicalReports',
    img: require('../../assets/images/homeTabs/medicalUpdates.png'),
  },
];

export const homeStaticPopularTopicsTabs = [
  {
    id: 1,
    label: 'medicalUpdates',
    img: require('../../assets/images/homeTabs/medicalUpdates.png'),
  },
  {
    id: 4,
    label: 'drugsAndDiseases',
    img: require('../../assets/images/homeTabs/drugsAndDiseases.png'),
  },
];

export const homeQuickAccessTabs = [
  {
    id: 0,
    key: TabKey.MedicalCalculators,
    label: 'medicalCalculators',
    img: require('../../assets/images/homeTabs/medicalCalculators.png'),
  },
  {
    id: 1,
    key: TabKey.LaboratoryValues,
    label: 'laboratoryValues',
    img: require('../../assets/images/homeTabs/labValues.png'),
  },
  {
    id: 3,
    key: TabKey.LatestInnovations,
    label: 'latestInnovations',
    img: require('../../assets/images/homeTabs/latestInnovations.png'),
  },
];

export const homePopularTopicsTabsApple = [
  {
    id: 1,
    label: 'medicalUpdates',
    img: require('../../assets/images/homeTabs/medicalUpdates.png'),
  },
];
